import { useTranslation } from 'next-i18next';
import Link from 'next/link';

const partnerPlaceholder = () => {
    const { t } = useTranslation('partners');

    return (
        <div className="col-12 col-sm-6 col-lg-4">
            {/*<!-- Card -->*/}
            <div className="card card-inactive card-fill">
                <div className="card-body">
                    <h3 className="text-center">{t('become-partner')}</h3>
                    <p className="text-muted text-center">{t('become-partner-body')}<br />{t('become-partner-body-2')}</p>
                    <div className="text-center">
                        <Link href="/contact">
                            <a className="btn btn-outline-secondary"><i className="fe fe-mail"></i> {t('contact')}</a>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default partnerPlaceholder;
